import React, { useEffect, useState } from "react";
// react-bootstrap components
import { Card, Form, Container, Row, Col } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { useParams } from "react-router";
import { apiService } from "../../../service/ApiService";
import { notificationService } from "../../../service/NotificationService";
import CreateButton from "components/Buttons/CreateButton";
import EditButton from "components/Buttons/EditButton";
import GeneralStoreSelect from "components/DropDowns/GeneralStoreSelect";
import StoreRoleSelect from "components/DropDowns/StoreRoleSelect";

import { useTranslation } from "react-i18next";

function StoreUserPage() {
  const {
    t,
  } = useTranslation();

  const backRoute = "/admin/store-users";
  const history = useHistory();
  const { id } = useParams();
  const [storeId, setStoreId] = useState(null);
  const [storeUserName, setStoreUserName] = useState("");
  const [storeUserPassword, setStoreUserPassword] = useState("");
  const [roleId, setRoleId] = useState(null);
  const [color, setColor] = useState("#28c76f");
  const [initialUser, setInitialUser] = useState({});

  const [storeUserDeleted, setStoreUserDeleted] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);

  const handleStoreId = (id) => {
    setStoreId(id);
  };

  const handleRoleId = (roleId) => {
    setRoleId(roleId);
  };

  const handlePassword = (e) => {
    const inputValue = e.target.value;
    if (/^\d*$/.test(inputValue)) setStoreUserPassword(inputValue);
  }

  useEffect(() => {
    if (!id) return;
    apiService
      .get(`api/v1/store-users/${id}`) 
      .then((storeUser) => {
        setInitialUser(storeUser);
        fillFields(storeUser);
      })
      .catch((error) => {
        notificationService.notifyError(error.message);
        history.push(backRoute);
      });
  }, []);

  const save = () => {
    setIsDisabled(true);
    const storeUser = {
      name: storeUserName,
      password: storeUserPassword === initialUser.password ? null : storeUserPassword,
      roleId: roleId,
      storeId: storeId,
      color: color,
      deleted: storeUserDeleted,
    };

    if (id) {
      apiService
        .putJson(`api/v1/store-users/${id}`, storeUser)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.userSavedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    } else {
      apiService
        .postJson("api/v1/store-users", storeUser)
        .then((resp) => {
          notificationService.notifySuccess(t("messages.userCreatedSuccessfully"));
          history.push(backRoute);
          setIsDisabled(false);
        })
        .catch((error) => {
          setErrorMessage(error.message);
          notificationService.notifyError(error.message);
          setIsDisabled(false);
        });
    }
  };

  const fillFields = (storeUser) => {
    setStoreUserName(storeUser.name);
    setStoreUserPassword(storeUser.password ? storeUser.password : null);
    setRoleId(storeUser.role ? storeUser.role.id : null);
    setColor(storeUser.color ? storeUser.color : "#28c76f");
    setStoreUserDeleted(storeUser.deleted);
  };

  return (
    <>
      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="stacked-form">
              <Card.Header>
                <Card.Title as="h4">{id ? t("pages.titles.editStoreUser") : t("pages.titles.createStoreUser")}</Card.Title>
              </Card.Header>
              <Card.Body>
                {errorMessage ? <div style={{ color: "crimson" }}>{errorMessage}</div> : null}
                <Form action="#" method="#">
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.name")}</label>
                        <Form.Control
                          placeholder={t("common.labels.name")}
                          required={true}
                          type="text"
                          value={storeUserName}
                          onChange={(event) => setStoreUserName(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.password")}</label>
                        <Form.Control
                          placeholder={t("common.labels.password")}
                          required={true}
                          type="password"
                          value={storeUserPassword}
                          onChange={handlePassword}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                    <Col>
                      <GeneralStoreSelect title={t("common.labels.store")} disabled={true} selectedStoreId={handleStoreId} />
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <StoreRoleSelect title={t("common.labels.role")} defaultValue={roleId} handler={handleRoleId} />
                    </Col>
                    <Col>
                      <Form.Group>
                        <label>{t("common.labels.color")}</label>
                        <Form.Control
                          placeholder={t("common.labels.color")}
                          required={true}
                          type="color"
                          value={color}
                          onChange={(event) => setColor(event.target.value)}
                        ></Form.Control>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="2">
                      <Form.Group>
                        <label className="d-flex align-items-center">
                          <Form.Check
                            type="switch"
                            id="switch-2"
                            checked={storeUserDeleted}
                            onChange={(e) => setStoreUserDeleted(e.target.checked)}
                          />
                          <span className="ml-1">{t("common.labels.inactive")}</span>
                        </label>
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
                <Row className="float-right">
                  <Col>{id ? <EditButton handler={save} disabled={isDisabled} /> : <CreateButton handler={save} disabled={isDisabled} />}</Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default StoreUserPage;
